
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/our-usp",
      function () {
        return require("private-next-pages/our-usp/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/our-usp"])
      });
    }
  